$(document).ready(function() {
    setTimeout(function() {
        var firstTrigger = $('.collapsible-tabs-heading .collapsible-trigger').first();
        if(firstTrigger.length) {
            firstTrigger.trigger('click');
        }
    }, 0);
    $('.collapsible-tabs-heading .collapsible-trigger').on('click', function() {
        $('.collapsible-tabs-heading .collapsible-trigger').removeClass('is-open');
        $('.collapsible-tabs-heading .collapsible-trigger').attr('aria-expanded', 'false');
        $(this).addClass('is-open');
        $(this).attr('aria-expanded', 'true');
        var ariaControls = $(this).attr('aria-controls');

        var contentTrigger = $('.collapsible-tabs-content .collapsible-trigger[aria-controls="' + ariaControls + '"]');

        if (contentTrigger.length && contentTrigger.attr('aria-expanded') !== 'true') {
            contentTrigger.trigger('click');
        }

        $('.collapsible-tabs-content .collapsible-trigger[aria-expanded="true"]').not(contentTrigger).each(function() {
            $(this).trigger('click'); 
        });
    });
    $('.variant-button-wrap .variant__label-size-guide').click(function() {
        $('.collapsible-trigger--size-guide').trigger('click');
        
        var targetOffset = $('.collapsible-tabs-content').offset().top;
        var heightHeader = $('.site-header').outerHeight();

        $('html, body').animate({
            scrollTop: targetOffset - heightHeader - 75
        }, 500); 
    })
});
